import fetchAPI from '_lib/api/fetchWrapper';
import apiRoute from '_lib/api/paths';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSaga, SagaType } from 'redux-toolkit-saga';
import { put } from 'typed-redux-saga';

import spatemsReducer from './spatemsReducers';
import { SpatemRequestPayload } from './spatemsTypes';

export function* getAllSpatems(action: PayloadAction<SpatemRequestPayload>) {
  const { roadSegmentIds } = action.payload;

  const segments = roadSegmentIds || [];
  const roadSegments = segments.map((id) => `roadSegmentId=${id}`).join('&');

  try {
    const response = yield fetchAPI(apiRoute.spatems(roadSegments));
    const results = response.results || response;
    
    // Transform API response to match expected format
    const transformedResults = Array.isArray(results)
      ? results.map((spatem: any) => {
          // Convert microdegrees to degrees (divide by 1e7)
          const lat = spatem.payload?.coords?.lat ? spatem.payload.coords.lat / 1e7 : 0;
          const lng = spatem.payload?.coords?.long ? spatem.payload.coords.long / 1e7 : 0;
          
          return {
            ...spatem,
            location: {
              type: 'Point' as const,
              coordinates: [lng, lat],
            },
            name: spatem.identifier || spatem.id,
            alive: true, // Default to alive, can be updated based on timestamp if needed
            // Add default distribution for compatibility with CardDetails component
            distribution: {
              kind: 'udp' as const,
              host: '',
              port: 0,
            },
          };
        })
      : [];
    console.log('°^° transformedResults', transformedResults);
    yield* put(spatemsReducer.actions.spatemsResponse(transformedResults));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR getAllSpatems >>>>>>> ', e);
  }
}

export const spatemsSagas = createSliceSaga({
  name: 'spatems',
  caseSagas: {
    spatemsRequest: getAllSpatems,
  },
  sagaType: SagaType.Watch,
});

